<template>
  <button
    type="button"
    class="flex w-full items-center gap-2 rounded-md border border-gray-200 bg-white px-2 py-1.5 text-sm text-gray-400 hover:bg-gray-50"
    @click="$emit('click')"
  >
    <SearchIcon class="h-4 w-4" />
    <span class="flex-1 text-left">Rechercher…</span>
    <span class="text-xs text-gray-400">&#8984;K</span>
  </button>
</template>

<script>
import { SearchIcon } from "@heroicons/vue/outline";

export default {
  components: {
    SearchIcon,
  },
  emits: ["click"],
};
</script>
